<template>
    <div class="chatroom-scoll" id="message-area">
        <message-item v-for="item in message" :key="item.id" :item="item" id="item.id"></message-item>
    </div>
</template>

<script>
import messageItem from './message-item'
export default {
  props: {
    message: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      viewID: ''
    }
  },
  methods: {

  },
  watch: {
    message: function (nexto, preo) {
      if (nexto.length) {
        const last = nexto[nexto.length - 1]
        this.viewID = last.id
        // 限制展示在页面上的消息条数
      }
    }
  },
  components: {
    messageItem
  },
  computed: {},
  created () {}
}
</script>

<style type="scss" scoped>
    .chatroom-scoll {
        max-height: 30vh;
        widows: 100%;
    }
</style>
